<template>
  <b-modal :visible="visible" centered lazy @hide="hide" hide-footer>
    <template slot="modal-header">
      <b-container class="text-center w-100 mt-2">
        <h5 class="fa fa-times float-right" @click="hide" />
        <h5>
          {{ $t('MODAL_finishplaylist_title') }}
        </h5>
      </b-container>
    </template>

    <!-- View for the User -->
    <div>
      <div class="row">
        <div class="col">
          <b-button
            variant="primary"
            class="w-100 mt-3"
            @click="redo"
            >{{ $t('MODAL_finishplaylist_redo') }}</b-button
          >
        </div>
        <div class="col">
          <b-button
            variant="primary"
            class="w-100 mt-3"
            @click="close"
            >{{ $t('MODAL_finishplaylist_finish') }}</b-button
          >
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'finishPlaylist',
  props: {
    visible: Boolean
  },
  methods: {
    redo() {
      this.$emit('redo');
    },
    close() {
      this.$emit('close');
    },
    hide() {
      this.$emit('hide')
    }
  },
};
</script>

<style lang="scss" scoped>
:global(.custom-control) {
  padding: 0;
  margin: 2px;
}

#feedback {
  font-size: 1rem;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/FinishPlaylist.vue